import { Button } from '@material-ui/core';
import PropTypes from 'prop-types';

import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';

import { MenuTypeIcon } from '../MenuTypeIcon';

import { useStyles } from './useStyles';

export const MenuCard = ({ menuCard, onClick }) => {
  const styles = useStyles();

  return (
    <Button
      className={styles.root}
      data-testid={`${menuCard.type}_MenuCard`}
      classes={{ label: styles.label }}
      onClick={onClick}
      key={menuCard.type}
      data-type={menuCard.type}
    >
      <MenuTypeIcon menuType={menuCard.type} />

      <CustomTypography
        variant={TYPOGRAPHY_VARIANT.medium14}
        className={styles.title}
      >
        {menuCard.label}
      </CustomTypography>
    </Button>
  );
};

MenuCard.propTypes = {
  menuCard: PropTypes.shape({
    label: PropTypes.string,
    type: PropTypes.string,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
};
